import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS, INFO_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  wrapper: {
    marginTop: 16
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  inputLabel: {
    marginBottom: 5
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 16,
    gap: 12
  },
  icon: {
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: 12
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: INFO_COLORS[700],
    cursor: 'pointer'
  },
  disabledTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: GRAY_COLORS[400],
    cursor: 'pointer'
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 400,
    color: GRAY_COLORS[600],
    cursor: 'pointer'
  },
  fileContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 12,
    borderRadius: 12,
    border: `1px solid ${GRAY_COLORS[200]}`
  },
  fileWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  fileIcon: {
    position: 'relative'
  },
  blueLines: {
    position: 'absolute',
    top: '55%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  date: {
    fontSize: 12,
    fontWeight: 400,
    color: GRAY_COLORS[600]
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    wordBreak: 'break-word'
  }
}))
